import React, { useState } from 'react';
import Paginate from './Paginate';

const Accordion = ({
  title,
  children,
  paginate = false,
  totalItems = 0,
  currentPage = 1,
  onPageChange = () => {},
  isOpenByDefault = true,
}) => {
  const [isOpen, setIsOpen] = useState(isOpenByDefault);

  const toggleAccordion = () => {
    setIsOpen((prev) => !prev);
  };

  return (
    <div>
      <button onClick={toggleAccordion} style={styles.accordionButton}>
        {title} {isOpen ? '-' : '+'}
      </button>
      {isOpen && (
        <div style={styles.accordionContent}>
          {children}
          {paginate && (
            <div style={{ marginTop: 16 }}>
              <Paginate
                totalItems={totalItems}
                currentPage={currentPage}
                onPageChange={onPageChange}
              />
            </div>
          )}
        </div>
      )}
    </div>
  );
};

const styles = {
    accordionButton: {
      display: 'block',
      width: '100%',
      textAlign: 'left',
      margin: '10px 0',
      padding: '15px',
      backgroundColor: '#f1f1f1',
      border: '2px solid #ccc',
      cursor: 'pointer',
      fontSize: '15px',
    },
    accordionContent: {
      padding: '15px',
      border: '2px solid #ccc',
      borderTop: 'none',
      backgroundColor: '#fff',
    },
  };

export default Accordion;
